<template>

    <div v-if="!hasBasketVoucher" class="d-flex align-items-center flex-wrap py-2 discountRow">
        <div class="mr-2">
            {{ $t('components.BasketVoucherRow.saleCode') }}
        </div>
        <div class="mr-sm-2 flex-grow-1 flex-sm-grow-0">
            <input class="simple-input w-100 w-sm-auto js-voucher-code" v-model="code" type="text">
        </div>
        <div class="ml-auto mt-2 mt-sm-0 ml-sm-0">

            <div class="d-flex align-items-center">
                <div class="tooltip tooltip--dark js-tooltip order-md-2 mx-4 mx-md-2">
                    <span class="tooltip__icon">?</span>
                    <div class="tooltip__window" style="--tooltipOffset:0px;">
                        {{ $t('components.BasketVoucherRow.saleCodeTooltip') }}
                    </div>
                </div>

                <button class="btn btn--small px-3 js-voucher-btn" @click.prevent="validate">
                    {{ $t('components.BasketVoucherRow.verifyCode') }}
                </button>
            </div>

        </div>


        <universal-popup :show="showPopup" :title="$t('components.BasketVoucherRow.popupTitle')" :content="error"
                         @close="showPopup = false"></universal-popup>
    </div>
    <div v-else class="row flex-wrap align-items-center py-2 no-gutters discountRow">
        <div class="col-auto pr-2 col-sm-8 d-flex align-items-center">
            {{ $t('components.BasketVoucherRow.saleCode') }} {{ voucherCode }}
        </div>
        <div class="col-auto ml-auto col-sm-4">
            <div class="d-flex align-items-center justify-content-end">
                <div class="text-nowrap text-transform-initial">
                    <span class="title" v-if="hasDiscount" v-text="voucherValue" />
                    <span v-else v-text="$t('components.BasketVoucherRow.youAreAlreadyApplyingAHigherDiscount')" />
                </div>
                <div class="remove-cross-wrap ico--fix-3n">
                    <button class="remove-cross remove-cross-small" @click="remove"></button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import UniversalPopup from "./UniversalPopup";

export default {
    data: function () {
        return {
            code: '',
            error: '',
            showPopup: false
        };
    },
    props: {
        basket: {}
    },
    computed: {
        hasBasketVoucher: function () {
            return this.basket.vouchers.length > 0
        },
        voucherCode: function () {
            if (!this.hasBasketVoucher) {
                return '';
            }
            return this.basket.vouchers[0];
        },
        voucherDiscount: function () {
            if (!this.hasBasketVoucher) {
                return '';
            }
            if (!this.hasDiscount) {
                return '';
            }
            var discounted = this.discount.discounted;
            var multipl = Math.pow(10, discounted.currency.rounding);
            var price = Math.round(discounted.priceWithVat * multipl) / multipl;
            return '-' + price + ' ' + discounted.currency.htmlString;
        },
        voucherValue: function () {
            if (
                !this.hasBasketVoucher
                || !this.hasDiscount
                || !this.discount.isDiscount
            ) {
                return '';
            }

            if (this.discount.isProcentual) {
                return '-' + this.discount.discount.value + ' %';
            }

            return '-' + this.$nf(this.discount.discount.value, 'currency' + this.discount.discounted.currency.code, 'cs-CZ');
        },
        discount() {
            var code = this.voucherCode;
            var discounts = this.basket.discounts.filter(function (item) {
                return item.uid === code;
            });
            return discounts.length > 0 ? discounts[0] : null;
        },
        hasDiscount() {
            return this.discount !== null;
        }
    },
    methods: {
        validate: function () {
            var vm = this;
            this.error = '';
            this.$store.dispatch('validateVoucher', {
                code: this.code
            })
                .then()
                .catch(function (payload) {
                    vm.showPopup = true;
                    vm.error = payload.error;
                })
        },
        remove: function () {
            if (this.hasBasketVoucher) {
                this.$store.dispatch('removeVoucher', {
                    code: this.voucherCode
                })
                    .then();
            }
        }
    },
    components: {
        UniversalPopup
    },
    mounted() {
        window.EventBus.$on('basket-voucher-row-set-code', (code) => {
            this.code = code;
            this.validate();
        });
    },
}
</script>
